const stats = [
  { value: "+500", label: "clientes asesorados" },
  { value: "27%", label: "ahorro medio en factura" },
  { value: "98%", label: "clientes satisfechos" },
  { value: "+13 años", label: "experiencia en el sector" },
];

export default function Trust() {
  const handleScroll = () => {
    const el = document.querySelector("#contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-24 bg-faro-navy relative overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-faro-teal transform translate-x-1/3 -translate-y-1/3" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-faro-yellow transform -translate-x-1/3 translate-y-1/3" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div>
            <span className="text-faro-teal-light text-sm font-semibold uppercase tracking-widest">
              Nuestra filosofía
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 mb-6 leading-tight">
              No vendemos energía.<br />
              <span className="text-faro-yellow">Orientamos personas.</span>
            </h2>
            <p className="text-white/70 text-lg leading-relaxed mb-6">
              En Faro Energía creemos que cada persona merece entender lo que paga y tener el control de sus decisiones energéticas. No somos una comercializadora ni un comparador. Somos tu consultor de confianza.
            </p>
            <p className="text-white/70 text-base leading-relaxed mb-8">
              Actuamos siempre en tu interés, con independencia total del mercado. Te explicamos tus opciones con honestidad, te acompañamos en cada paso y nos aseguramos de que tomes la mejor decisión para tu situación real.
            </p>
            <button
              onClick={handleScroll}
              className="bg-faro-yellow hover:bg-faro-yellow-light text-faro-navy font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Quiero mi estudio gratuito
            </button>
          </div>

          {/* Right: Stats + Image */}
          <div className="flex flex-col gap-6">
            {/* Stats */}
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-white/5 border border-white/10 rounded-xl p-6"
                >
                  <div className="text-faro-yellow text-3xl font-bold mb-1">
                    {stat.value}
                  </div>
                  <div className="text-white/60 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Testimonial */}
            <div className="bg-white/5 border border-white/10 rounded-xl p-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center text-faro-teal-light flex-shrink-0">
                  <i className="ri-double-quotes-l text-2xl" />
                </div>
                <div>
                  <p className="text-white/80 text-sm leading-relaxed italic">
                    "Llevaba años pagando de más sin saberlo. En Faro Energía me analizaron la factura en una semana y ahora ahorro más de un 30% al año. El trato fue excelente desde el primer momento."
                  </p>
                  <div className="mt-3 flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-faro-teal/20 rounded-full text-faro-teal-light text-xs font-bold">
                      JM
                    </div>
                    <div>
                      <p className="text-white text-sm font-medium">Jordi M.</p>
                      <p className="text-white/40 text-xs">Pyme, Barcelona</p>
                    </div>
                    <div className="ml-auto flex gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <div key={i} className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-star-fill text-faro-yellow text-xs" />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
